// extracted by mini-css-extract-plugin
var _1 = "T1ZhZvMS";
var _2 = "Y7VyBq0s";
var _3 = "s3zQh4Ub";
export { _1 as "link", _2 as "list", _3 as "mainBlock" }
